const backgraundColorList = [
    'color-mix(in srgb, var(--color-green) 8%, transparent)',
    'color-mix(in srgb, var(--color-blue-deep) 8%, transparent)',
    'color-mix(in srgb, var(--color-accent-vivid) 8%, transparent)',
    'color-mix(in srgb, var(--color-green) 8%, transparent)',
    'color-mix(in srgb, var(--color-yellow) 8%, transparent)',
    'color-mix(in srgb, var(--color-danger) 8%, transparent)',
    'color-mix(in srgb, var(--color-danger) 8%, transparent)',
    'color-mix(in srgb, var(--color-blue-deep) 8%, transparent)'
];

export default backgraundColorList;